var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.679,
    height: 33.278,
    viewBox: "0 0 32.679 33.278",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-user-6889748",
    transform: "translate(-3.359 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M11.9,10.3a7.8,7.8,0,1,1,2.284,5.514A7.771,7.771,0,0,1,11.9,10.3Zm-1.641,12.97a.553.553,0,0,1-.684-.87l.09-.071a.553.553,0,1,1,.684.87Zm1.8-1.225a.553.553,0,0,1-.554-.956q.55-.318,1.147-.6c.385-.183.78-.356,1.185-.51a.554.554,0,0,1,.629.172A6.752,6.752,0,0,0,16.8,22.005a6.683,6.683,0,0,0,8.132-1.864.554.554,0,0,1,.672-.155A16.345,16.345,0,0,1,36.038,35.224a.554.554,0,0,1-.554.554H3.913a.554.554,0,0,1-.554-.554A16.294,16.294,0,0,1,7.951,23.872a.553.553,0,0,1,.8.766A15.157,15.157,0,0,0,4.48,34.669H34.921a15.237,15.237,0,0,0-9.388-13.522,7.792,7.792,0,0,1-11.666,0c-.249.1-.5.213-.739.33-.358.171-.716.361-1.069.566Zm2.91-16.474A6.689,6.689,0,1,0,19.7,3.61a6.667,6.667,0,0,0-4.729,1.958Z",
    transform: "translate(0)",
    fill: "#5D0D19"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.944c36eb2055675fdb42bd8519fc8b32.svg";
export { ForwardRef as ReactComponent };